import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-radio-list',
  styles: `
    .custom-radio-group {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .custom-radio {
      border-radius: var(--mar-spacing-default-md, 12px);
      border: var(--mar-border-width-thin, 1px) solid var(--mar-border-secondary-default, #CFCFCF);
      background: var(--mar-foreground-secondary-default, #FFF);
      padding: var(--mar-spacing-default-lg, 16px);

      display: flex;
      justify-content: space-between;
      align-items: center;

      cursor: pointer;
      transition: background-color 0.2s ease;

      input[type="radio"] {
        display: none;
      }

      .label {
        color: var(--mar-foreground-primary-default);
        font-family: var(--mar-open-sans, "Open Sans"), sans-serif;
        font-size: var(--mar-font-size-14px, 14px);
        font-style: normal;
        font-weight: var(--mar-font-weight-700, 700);
        line-height: var(--mar-line-height-20px, 20px); /* 142.857% */
        letter-spacing: var(--mar-letter-spacing-0, 0px);
      }

      .icon {
        font-size: 24px;
        color: var(--mar-foreground-primary-default);
      }

      &:hover {
        @media (min-width: 600px) {
          background-color: var(--mar-foreground-secondary-hover);
          border: var(--mar-border-width-thin, 1px) solid var(--mar-border-secondary-hover, #CFCFCF);
        }
      }

      &.selected {
        background-color: var(--mar-foreground-secondary-active);
        border: var(--mar-border-width-thin, 1px) solid var(--mar-border-secondary-active, #CFCFCF);
      }
    }
  `,
  template: `
    @if (props.label) {
      <label>{{ props.label }}</label>
    }
    <div class="custom-radio-group">
      @for (option of optionsList; track $index) {
        <label
          class="custom-radio"
          [class.selected]="formControl.value === option.value"
          >
          <input
            (click)="emitChange()"
            type="radio"
            [value]="option.value"
            [formControl]="formControl"
            />
          <span class="label">{{ option.label }}</span>
          <mat-icon class="icon">arrow_forward</mat-icon>
        </label>
      }
    </div>
    `,
  standalone: false
})
export class FormlyFieldRadioListComponent extends FieldType<FieldTypeConfig> {
  get optionsList() {
    return this.props.options as { label: string, value: string }[];
  }

  emitChange() {
    this.props.onInteraction?.();
  }
}
